<template>





    <v-layout row>
      <v-flex xs12 sm6 offset-sm3 justify-center>
        <v-card>
          <div class="container">
             <div class="container">
             <v-btn icon @click="onClickGetCSV()">
              <v-icon>window</v-icon> Get MYOID-CSV File
            </v-btn>
            </div>

            <div class="container">
              <label>
                <input  v-show="false" type="file" name="file" multiple id="file" ref="file" v-on:change="handleFileUpload()"/>
              </label>
             <!-- <br>
              <progress max="100" :value.prop="uploadPercentage"></progress>
              <br>-->
               <v-btn color="blue darken-1" flat @click="$refs.file.click()">UPLOAD NEW </v-btn>
            </div>
            <div v-if="ShowUploadNew" class="container">
             <v-btn icon @click="onClickUpdateCleanLoadStart()">
              <v-icon>window</v-icon>Clean LoadStart
            </v-btn>
            </div>


          </div>

   
        </v-card>
      </v-flex>

    </v-layout>



</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { router } from '@/router';
import { authenticationService } from '@/services';
import { myoidService } from '@/services';
import transfereHub from '@/hubs/transfere-hub'

import axios from 'axios';

import { store } from '@/store';
import { mapMutations } from "vuex";
import * as CONFIG from '@/config/config'

export default {
    data () {
        return {
            user: authenticationService.currentUserValue,
            ShowUploadNew: false,
            file: '',
            snackbar: false,
            message: '',
            uploadPercentage: 0
        };
    },

    methods: {
      ...mapMutations(["setSnackbar"]),
     
          async onClickGetCSV() {
             const currentUser = authenticationService.currentUserValue || {};
              axios({
                url: CONFIG.CORE_URL + '/myoid/downloadCSV',
                method: 'GET',
                responseType: 'blob', // important,
                headers: { Authorization: 'Bearer ' + currentUser.token},
              }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'MYOID-Liste.csv');
                document.body.appendChild(link);
                link.click();
              });

          },

          async onClickUpdateCleanLoadStart() {
            this.setSnackbar("Load Start wird bereinigt","success","5");
            await myoidService.CleanLoadStart();
            this.setSnackbar("Load Start  bereinigt","success","5");
          },

           async handleFileUpload(){
             var _this = this;
              _this.setSnackbar("Uploading...","info","100");
              /*
                Initialize the form data
              */
              let formData = new FormData();
              const currentUser = authenticationService.currentUserValue || {};

              this.file = this.$refs.file.files[0];
              /*
                Add the form data we need to submit
              */
              formData.append('myfile', this.file);

              /*
                Make the request to the POST /single-file URL
              */
              await axios.post( CONFIG.CORE_URL + '/myoid/admin_fileupload/post',
                formData,
                {
                  headers: {
                      'Authorization': 'Bearer ' + currentUser.token,
                      'Content-Type': 'multipart/form-data'
                  },
                  onUploadProgress: function( progressEvent ) {
                    this.uploadPercentage = parseInt( Math.round( ( progressEvent.loaded * 100 ) / progressEvent.total ) );
                  }.bind(this)
                }
              ).then(function(){
                console.log('SUCCESS!!');
                _this.setSnackbar("Upload success","success","5");
                _this.uploadPercentage = 0;
         
              })
              .catch(function(error){
                    if (error.response) {
                      console.log(JSON.stringify(error));
                      console.log(error.response.status);
                      console.log(error.response.headers);
                    }
                    _this.setSnackbar("Upload failure","error","5");
                    _this.uploadPercentage = 0;
   
              });
           },   
           
  
    },



    created () { 
        this.$transfereHub.$on('MyoidIDChanged', this.onMyoidChanged)
        if(this.user.username=='tro0s') {
          this.ShowUploadNew=true;
        }
    },


    beforeDestroy () {
       this.$transfereHub.$off('MyoidIDChanged', this.onMyoidChanged)
    },
};
</script>